// extracted by mini-css-extract-plugin
module.exports = {"contactModal":"VacanciesFormModal_contactModal__i29z5","closeButton":"VacanciesFormModal_closeButton__IVqE_"};